import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { IContactRole } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'

const tsdContactRoleListData = undefined as unknown as IContactRole[]

export const getTsdContactRoleListData = getListDataFunctionFactory<
  IContactRole[]
>({
  listData: tsdContactRoleListData,
  storageKey: 'tsdcontactroles',
  getStartingListData: getStartingTsdContactRoleListData,
})

export async function getTsdContactRoleDataById(
  id: TEntityId
): Promise<IContactRole> {
  const list: IContactRole[] = await getTsdContactRoleListData()
  if (!list) {
    throw new Error(`getTsdContactRoleListData returned undefined/null`)
  }
  const c = list.find((tsdContactRole) => tsdContactRole.id === id)
  if (!c) {
    throw new Error(`Can't find tsdContactRole '${id}'`)
  }
  return c
}

export async function getTsdContactRoleDataByLabel(
  label: string
): Promise<IContactRole> {
  const list: IContactRole[] = await getTsdContactRoleListData()
  if (!list) {
    throw new Error(`getTsdContactRoleListData returned undefined/null`)
  }
  const c = list.find((tsdContactRole) => tsdContactRole.label === label)
  if (!c) {
    throw new Error(`Can't find tsdContactRole '${label}'`)
  }
  return c
}

export async function getStartingTsdContactRoleListData(): Promise<
  IContactRole[]
> {
  return [
    { id: 'XXTCR001', hrid: 'TCR001', label: 'Billing', canBeDeleted: true },
    { id: 'XXTCR002', hrid: 'TCR002', label: 'Engineer', canBeDeleted: true },
    {
      id: 'XXTCR003',
      hrid: 'TCR003',
      label: 'Channel Manager',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXTCR004',
      hrid: 'TCR004',
      label: 'Project Manager',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
